/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const Root = styled(Box)(({theme}) => ({
  height: '68px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  flexShrink: 0,
}));

export const StartBox = styled(Root)(() => ({
  background: 'linear-gradient(180deg, #4A4B4F 0%, #696A6E 100%)',
  boxShadow: '0 12px 16px -16px #A5A6AB inset',
}));

export const ActiveBox = styled(Root)(() => ({
  background: 'linear-gradient(180deg, #6C394B 0%, #97526A 100%)',
  boxShadow: '0 12px 16px -16px #E886A7 inset',
}));

export const BusinessBox = styled(Root)(() => ({
  background: 'linear-gradient(180deg, #664214 0%, #8E5E1F 100%)',
  boxShadow: '0 12px 16px -16px #DB9640 inset',
}));

export const PremiumBox = styled(Root)(() => ({
  background: 'linear-gradient(180deg, #214D72 0%, #316E9F 100%)',
  boxShadow: '0 12px 16px -16px #58ACF2 inset',
}));

export const UltraBox = styled(Root)(() => ({
  background: 'linear-gradient(180deg, #434578 0%, #6062A8 100%)',
  boxShadow: '0 12px 16px -16px #989CFF inset',
}));

export const PopularBadge = styled(Box)(({theme}) => ({
  display: 'flex',
  padding: theme.spacing(1, 2),
  borderRadius: '100px',
  background: 'linear-gradient(180deg, #177768 0%, #1E9481 100%)',
  boxShadow: '0 -1px 4px 0 #CCEBE3 inset',

  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '14px',
  letterSpacing: '2.4px',
  textTransform: 'uppercase',
}));
